var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6312 2.35249C12.0015 0.72279 9.69189 -0.217038 7.15236 0.0429141C3.48303 0.412847 0.463579 3.3923 0.0536541 7.06163C-0.496246 11.9107 3.25307 16 7.98221 16C11.1716 16 13.9111 14.1303 15.1909 11.4408C15.5108 10.771 15.0309 10.0011 14.2911 10.0011C13.9211 10.0011 13.5712 10.2011 13.4112 10.531C12.2814 12.9606 9.57192 14.5003 6.61246 13.8404C4.39286 13.3505 2.60319 11.5408 2.13327 9.32122C1.29343 5.44193 4.24289 2.00256 7.98221 2.00256C9.6419 2.00256 11.1216 2.69243 12.2014 3.78223L10.6917 5.29196C10.0618 5.92184 10.5017 7.00164 11.3916 7.00164H14.9809C15.5308 7.00164 15.9807 6.55173 15.9807 6.00183V2.41248C15.9807 1.52264 14.9009 1.07273 14.2711 1.70261L13.6312 2.35249Z",
    fill: "#0078D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reloadIcon.d420aa96c177493841970dfa7f582684.svg";
export { ForwardRef as ReactComponent };